var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFireCracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73 8.387a1.09 1.09 0 011.005.294l9.253 9.253a1.09 1.09 0 01-.394 1.795L8.268 23.9c-2.182.805-4.305-1.318-3.5-3.5L8.94 9.075a1.09 1.09 0 01.79-.688z",
    fill: "#FDAD15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.22 9.452a1.09 1.09 0 010 1.542l-1.156 1.157a1.09 1.09 0 01-1.543-1.543l1.157-1.156a1.09 1.09 0 011.542 0z",
    fill: "#80D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.02 3.018a1.09 1.09 0 011.38.69c.489 1.467.227 3.075-.079 4.198-.19.697-.428 1.385-.752 2.032a1.09 1.09 0 01-1.951-.974 8.89 8.89 0 00.599-1.632c.272-.997.396-2.089.114-2.935a1.09 1.09 0 01.69-1.38z",
    fill: "#FFBB95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.393 15.796a1.09 1.09 0 00-.374-1.497c-1.184-.71-2.546-.92-3.54-.973a9.358 9.358 0 00-1.802.058 1.09 1.09 0 00.308 2.159 7.686 7.686 0 011.38-.039c.837.044 1.789.22 2.532.666a1.09 1.09 0 001.497-.375z",
    fill: "#00B05D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.305 6.367a1.09 1.09 0 010 1.543l-.771.77A1.09 1.09 0 0119.99 7.14l.772-.772a1.09 1.09 0 011.542 0z",
    fill: "#FA3F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.785 11.38a1.09 1.09 0 01-1.09 1.09h-.772a1.09 1.09 0 010-2.18h.771c.602 0 1.09.487 1.09 1.09z",
    fill: "#9C4D20"
  })));
}

export default SvgFireCracker;